import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Handles the OAuth callback when opened in a popup window.
 * The backend redirects here after successful Google OAuth.
 * This page posts a message to the opener and closes.
 */
export default function OAuthPopupHandler() {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const isSuccess = !params.get("authError") && !params.get("openLogin") && !params.get("openSignup");

    if (window.opener) {
      if (isSuccess) {
        window.opener.postMessage({ type: "GOOGLE_AUTH_SUCCESS" }, window.location.origin);
      } else {
        window.opener.postMessage({
          type: "GOOGLE_AUTH_ERROR",
          message: params.get("authError") || params.get("authMessage") || "Authentication failed",
        }, window.location.origin);
      }
      window.close();
    } else {
      // Not in a popup — redirect normally
      const redirectTo = isSuccess ? "/dashboard" : `/?${location.search}`;
      window.location.replace(redirectTo);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
